import type { ExtractPropTypes } from 'vue'
import { getCurrentInstance } from 'vue'

export const paramItemProps = {
	label: {
		type: String,
		default: '',
	},
	value: {
		type: [String, Number],
		default: '',
	},
	tip: {
		type: String,
		default: '',
	},
	labelWidth: {
		type: String,
		default: rawProps => {
			const instance = getCurrentInstance()
			return instance?.parent?.exposed?.getLabelWidth() || rawProps.labelWidth || 'auto'
		},
	},
	wrap: Boolean,
} as const

export type ParamItemProps = ExtractPropTypes<typeof paramItemProps>
